<template>
    <v-row>
        <v-col cols="12" align="center">

            <v-btn x-large v-if="pwaPrompt" color="primary" @click.native="promptInstall()">
                <v-icon left>
                    mdi-application-cog-outline
                </v-icon>
                {{ $t("install_app") }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>

// Utilities

export default {
    name: "installApp",
    methods: {
        promptInstall: function () {
            let _ = this;
            // Show the prompt:
            _.$pwa.pwaRsp.prompt.prompt().then(prompt => {
                _.$pwa.pwaRsp.prompt = false;
                if (prompt.userChoice === "accepted") {
                    console.log("User accepted the install prompt");
                } else {
                    console.log("User dismissed the install prompt");
                }
            });
            _.$pwa.pwaRsp.prompt = false;
        }
    },
    watch: {
        pwaPrompt: function (val) {
            if (val) {
                this.$refs.installBtn.$el.click()
            }
        },
    },
    computed: {
        pwaPrompt() {
            return this.$pwa.pwaRsp.prompt;
        },
    },
    mounted() {
        let _ = this;
    },
};
</script>